<div class="dialog-content">
  <rt-dialog-header
    [heading]="'app.email_provider_google.title' | translate"
    icon="google-gmail"
    iconSize="medium"
  />

  <rt-dialog-body variant="white" layout-vertical>
    @if (googleConnected) {
      <rt-message variant="context-information">
        {{ 'app.email_provider_google.mailbox_connected' | translate }}
      </rt-message>
    }

    @if (!googleConnected) {
      <rt-message variant="context-warning">
        <strong>{{ 'app.email_provider_mailbox.notice' | translate }}</strong>
        <br />
        {{ 'app.email_provider_mailbox.sync_info' | translate }}
        <a
          href="{{ 'app.support_resources.mailbox_sync' | translate }}"
          target="_blank"
          class="infobox-link"
        >
          {{ 'app.email_provider_mailbox.read_more_here' | translate }}
        </a>
      </rt-message>
      <rt-divider variant="default" />
      <p>{{ 'app.email_provider_google.info' | translate }}</p>

      @if (errorMessage && errorProvider === EmailProviders.Google) {
        <rt-message variant="context-error" margin-bottom>
          {{ errorMessage }}
        </rt-message>
      }

      <rt-divider variant="default" />
      <rt-group layout>
        <a rt-button variant="primary" margin-right-small (click)="connectClick()">
          <rt-icon name="swap-horiz" />
          @if (errorMessage) {
            {{ 'app.email_provider_common.connect_again' | translate }}
          }
          @if (!errorMessage) {
            {{ 'app.email_provider_common.connect' | translate }}
          }
        </a>
        <rt-button variant="plain" (click)="cancelClick()">
          {{ 'app.common.cancel' | translate }}
        </rt-button>
      </rt-group>
    }
  </rt-dialog-body>
</div>

<div class="dialog-info-box">
  <rt-heading variant="heading large light">
    <rt-icon name="info" colorToken="colorIconInfoDefault" />
    {{ 'app.email_provider_security_info.title' | translate }}
  </rt-heading>
  <p margin-top-small [innerHTML]="'app.email_provider_security_info.info' | translate"></p>

  <dl margin-tb>
    <dt>
      {{ 'app.email_provider_security_info.li_1.title' | translate }}
    </dt>
    <dd>
      {{ 'app.email_provider_security_info.li_1.description' | translate }}
    </dd>
  </dl>
  <!--    TODO: Uncomment when we start encrypting passwords to mailboxes-->
  <!--    <div layout-horizontal>-->
  <!--      <rt-icon margin-top-small margin-right-small name="check"></rt-icon>-->
  <!--      <div layout-vertical>-->
  <!--        <h5 margin-top-small text-bold text-darkest>-->
  <!--          {{ 'app.email_provider_security_info.li_2.title' | translate }}-->
  <!--        </h5>-->
  <!--        <p>{{ 'app.email_provider_security_info.li_2.description' | translate }}</p>-->
  <!--      </div>-->
  <!--    </div>-->
</div>
